const OPTS = ["all", "collection", "payout", "chargeback"];

export const WalletFilter = ({ value, onChange, options = OPTS, prefix = "wallet-filter" }) => (
  <div className="flex flex-wrap gap-2">
    {options.map((o) => (
      <button
        key={o}
        data-testid={`${prefix}-${o}`}
        onClick={() => onChange(o)}
        className={`rounded-full px-4 py-1.5 text-sm font-medium capitalize transition-colors ${value === o ? "bg-[#0A1F44] text-white" : "border border-slate-200 bg-white text-slate-600 hover:bg-slate-50"}`}
      >
        {o}
      </button>
    ))}
  </div>
);
